<button class="fav-button" mat-mini-fab color="accent" (click)="toggleFavourite()" *ngIf="!addApplication">
  <!-- <ng-template [ngIf]="favourite" [ngIfElse]="favElseBlock"> -->
    <mat-icon>{{favourite ? 'favorite' : 'favorite_border'}}favorite</mat-icon>
  <!-- </ng-template> -->
  <!-- <ng-template #favElseBlock> -->
    <!-- <mat-icon>favorite_border</mat-icon> -->
  <!-- </ng-template> -->
</button>

<form [formGroup]="appForm">

  <mat-form-field appearance="fill" class="full-width">
    <mat-label>Application Name</mat-label>
    <input matInput required placeholder="Application Name" formControlName="name">
  </mat-form-field>

  <mat-form-field class="full-width" *ngIf="!addApplication">
    <mat-label>Application GUID</mat-label>
    <input matInput readonly placeholder="Application GUID" formControlName="applicationGuid">
  </mat-form-field>

  <mat-form-field appearance="fill" class="full-width">
    <mat-label>Description</mat-label>
    <textarea rows="5" matInput placeholder="Description" formControlName="description"></textarea>
  </mat-form-field>

  <mat-form-field appearance="fill" class="full-width">
    <mat-label>Comments</mat-label>
    <textarea rows="5" matInput placeholder="Comments" formControlName="comments"></textarea>
  </mat-form-field>

  <mat-form-field appearance="fill" class="full-width" *ngIf="!addApplication">
    <mat-label>License Key Filename</mat-label>
    <input matInput placeholder="License Key Filename" formControlName="licenseKeyName">
  </mat-form-field>

  <mat-form-field class="full-width" *ngIf="!addApplication">
    <mat-label>Application Password</mat-label>
    <input matInput readonly placeholder="Application Password" formControlName="password" #password>
    <button mat-icon-button matIconSuffix matTooltip="Copy password to clipboard." (click)="copyInput(password)">
      <mat-icon>content_copy</mat-icon>
    </button>
  </mat-form-field>

  <mat-form-field class="full-width" *ngIf="!addApplication">
    <mat-label>Public Key</mat-label>
    <textarea rows="5" matInput readonly placeholder="Public Key" formControlName="publicKey" #publickey></textarea>
    <button mat-icon-button matIconSuffix matTooltip="Copy public key to clipboard." (click)="copyInput(publickey)">
      <mat-icon >content_copy</mat-icon>
    </button>
  </mat-form-field>

  <mat-checkbox formControlName="noLicensedDownload" class="form-checkbox">Hide License File</mat-checkbox>

  <div *nbIsGranted="['edit', 'application_hidden']">
    <mat-checkbox formControlName="hidden" class="form-checkbox">Hidden</mat-checkbox>
  </div>

  <div *nbIsGranted="['edit', 'create_demo_access']">
    <mat-checkbox formControlName="enableDemos" class="form-checkbox">Allow External Demos</mat-checkbox>

    <mat-form-field class="full-width" *ngIf="appForm.value.enableDemos">
      <mat-label>Demo Password</mat-label>
      <input matInput placeholder="Demo Password" formControlName="demoPassword" #demopassword>
      <button mat-icon-button matIconSuffix matTooltip="Copy password to clipboard." (click)="copyInput(demopassword)">
        <mat-icon>content_copy</mat-icon>
      </button>
    </mat-form-field>

    <mat-form-field class="full-width" *ngIf="appForm.value.enableDemos">
      <mat-label>Demo IP Filter</mat-label>
      <input matInput placeholder="0.0.0.0" formControlName="demoIPFilter">
    </mat-form-field>

    <mat-form-field class="full-width" *ngIf="appForm.value.enableDemos">
      <mat-label>Maximum Demo Days</mat-label>
      <input matInput type="number" placeholder="Maximum Demo Days" formControlName="maxDemoDays">
    </mat-form-field>
  </div>

</form>